import React, { ReactElement } from 'react';
import { KiteCard } from '@kite/react-kite';
import quoteImage from '../../assets/quote.png';
import './QuoteCard.scss';

interface IQuoteCard {
    quote: string;
    attribution: string;
}
export function QuoteCard({ inputs }: { inputs: IQuoteCard }): ReactElement {
    const { quote, attribution } = inputs;
    return (
        <KiteCard className="quote-card" elevation={1}>
            <img
                src={quoteImage}
                width={40}
                height={31}
                alt=""
                aria-hidden
                className="quote-card__decorator"
            />
            <div className="quote-card__quote">
                <blockquote>
                    <p className="quote-card__text">{quote}</p>
                </blockquote>
                <p className="quote-card__attribution">– {attribution}</p>
            </div>
        </KiteCard>
    );
}
